import React from "react";
import { FlexDiv } from "../assets/styles/style";
import AllListeningComponents from "../components/Listening/AllListeningComponents";


const Listening = () => {
  return (
    <>
      <FlexDiv>
        <AllListeningComponents />
      </FlexDiv>
    </>
  );
};

export default Listening;

//Currently This page is being used to render all the cards and components during development 
